/**
 * Helper functions cookie.js
 *
 * @namespace cookie
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/cookie.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * @function cookie.getCookie
 * @param {string} cname
 * @returns {string}
 */
export const getCookie = function(cname) {
    let name = cname + "=",
        ca = document.cookie.split(';'),
        i,
        c,
        ca_length = ca.length;
    for (i = 0; i < ca_length; i += 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * @function cookie.setCookie
 * @param {*} variable
 * @param {*} value
 * @param {*} expires_seconds
 */
export const setCookie = function(variable, value, expires_seconds) {
    let d = new Date();
    d = new Date(d.getTime() + 1000 * expires_seconds);
    document.cookie = variable + '=' + value + '; expires=' + d.toGMTString() + ';';
}

/**
 * @function cookie.hasCookie
 * @param {string} cname
 * @returns {boolean}
 */
export const hasCookie = function checkCookie(cname) {
    let cookie = getCookie(cname);
    return cookie !== "" && cookie !== null && cookie !== undefined;
}